module.exports = __webpack_public_path__ + "img/logo-login.23ad6830.png";